<template lang="pug">
</template>

<script>
import {mapState} from "vuex";
import {debounce} from "@/utils";

export default {
  data() {
    return {
      isUserbackReady: false
    }
  },
  mounted() {
    this.watchUserBack()
  },
  computed: {
    ...mapState('user', ['member']),
    ...mapState(['subscriptions']),
    payload() {
      // userback only allow string, boolean and number type
      return {
        id: this.member?.id ?? '',
        pid: this.member?.pid ?? '',
        company_slug: this.member?.company?.slug ?? '',
        name: this.member?.name ?? '',
        phone: this.member?.phone ? `+${this.member.phone}` : '',
        email: this.member?.user.email ?? '',
        roles: this.member?.roles?.join(', ') ?? '',
        type: this.member?.type ?? '',
        subscriptions: this.allSubscriptionsAndTrials ?? '',
      }
    },
    allSubscriptionsAndTrials() {
      const items = []
      const wordsToFind = ['Trial', 'Subscription']

      Object.keys(this.subscriptions).forEach(key => {
        if (wordsToFind.some(word => key.includes(word)) && this.subscriptions[key]?.value) {
          items.push(this.subscriptions[key].data.plan)
        }
      })
      return items.join(', ')
    },
    canIdentify() {
      return Boolean(this.isUserbackReady && this.member?.id)
    }
  },
  watch: {
    canIdentify: {
      immediate: true,
      handler(value) {
        if (value) {
          this.updateUserbackIdentity()
        }
      },
    }
  },
  methods: {
    watchUserBack(retryCount = 10) {
      if (retryCount === 0) {
        console.error('Failed to set userback data')
        return
      }

      if (!this.$userback) {
        setTimeout(() => this.watchUserBack(retryCount - 1), 2000)
        return
      }

      this.isUserbackReady = true
    },
    updateUserbackIdentity: debounce(function () {
      this.$userback.identify(this.member.id, this.payload)
    }, 1000),
  },
}
</script>

<style scoped>

</style>